import { useNavigate } from "react-router-dom";
export default function PageHeader({ eyebrow, title, copy, back = true }) {
  const navigate = useNavigate();
  return (
    <div className="page-header">
      {back && (
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="icon-button mb-3"
          aria-label="Go back"
        >
          <i className="fa-solid fa-arrow-left" />
        </button>
      )}
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h1>{title}</h1>
      {copy && <p className="mb-1">{copy}</p>}
    </div>
  );
}
